import React, { useState } from 'react';
import '../styles/BusinessBenefits.css';
import QuoteModal from './QuoteModal';

const BusinessBenefits = () => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };

  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };

  const benefits = [
    {
      id: 1,
      title: 'Low Minimum Order Quantity',
      description: 'Start your business without heavy investment. We understand that every business grows at its own pace. Our flexible MOQ allows small distributors and clinics to start with confidence.',
      highlight: 'Start Small, Grow Big',
      icon: '📦',
      stat: 'No MOQ Pressure',
      color: '#4a90e2'
    },
    {
      id: 2,
      title: 'Custom Branding Options',
      description: 'Your brand. Your identity. Your success. Get complete flexibility to create your own packaging, logo placement, and brand story. Stand out in your market with exclusive branding.',
      highlight: '100% Private Label',
      icon: '🎨',
      stat: 'Your Own Brand',
      color: '#7b2cbf'
    },
    {
      id: 3,
      title: 'Quick Turnaround Time',
      description: 'Time is money. We deliver your orders in record time. No waiting for months. No stockouts. Keep your inventory moving and your customers happy.',
      highlight: 'Faster Delivery',
      icon: '⚡',
      color: '#20c997'
    },
   
  ];

  const additionalPerks = [
    {
      perk: 'Marketing Support',
      icon: '📢'
    },
    {
      perk: 'Pan-India Service Network',
      icon: '🇮🇳'
    },
    {
      perk: 'Priority Customer Support',
      icon: '⚡'
    },
  ];

  return (
    <>
      <section id="business-benefits" className="business-benefits-section">
        <div className="business-benefits-container">
          
          {/* Section Header */}
          <div className="business-benefits-header">
            <span className="business-benefits-tagline">Why Distributors Love Us</span>
            <h2 className="business-benefits-title">
              Business Benefits That <span className="business-benefits-highlight">Actually Matter</span>
            </h2>
            <div className="business-benefits-underline"></div>
            <p className="business-benefits-subtitle">
              No fluff. No hidden terms. Just real advantages that help your business grow.
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="business-benefits-grid">
            {benefits.map((benefit) => (
              <div key={benefit.id} className="business-benefits-card">
                <div className="business-benefits-card-header">
                  <div className="business-benefits-card-icon" style={{ background: `${benefit.color}20` }}>
                    <span>{benefit.icon}</span>
                  </div>
                  <div className="business-benefits-card-stat" style={{ color: benefit.color }}>
                    {benefit.stat}
                  </div>
                </div>
                <h3 className="business-benefits-card-title">{benefit.title}</h3>
                <p className="business-benefits-card-description">{benefit.description}</p>
                <div className="business-benefits-card-footer">
                  <span className="business-benefits-card-highlight">{benefit.highlight}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Value Proposition Banner */}
          <div className="business-benefits-value-banner">
            <div className="business-benefits-value-left">
              <div className="business-benefits-value-icon">💰</div>
              <div>
                <h3>Higher Margins. Better ROI.</h3>
                <p>Our pricing model ensures you get the best returns on your investment</p>
              </div>
            </div>
            
          </div>

          {/* Perks Section */}
          <div className="business-benefits-perks">
            <div className="business-benefits-perks-header">
              <h3>What Else You Get</h3>
              <p>Because we believe in adding value beyond products</p>
            </div>
            <div className="business-benefits-perks-grid">
              {additionalPerks.map((perk, index) => (
                <div key={index} className="business-benefits-perk-item">
                  <span className="business-benefits-perk-icon">{perk.icon}</span>
                  <span className="business-benefits-perk-text">{perk.perk}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Comparison Table - Us vs Others */}
          <div className="business-benefits-comparison">
            <div className="business-benefits-comparison-header">
              <h3>Why Choose Us Over Others?</h3>
              <p>See the difference yourself</p>
            </div>
            <div className="business-benefits-comparison-table">
              <div className="business-benefits-comparison-row business-benefits-comparison-header-row">
                <div className="business-benefits-comparison-cell">Feature</div>
                <div className="business-benefits-comparison-cell">Other Brands</div>
                <div className="business-benefits-comparison-cell business-benefits-our-brand">Preferred Audiology</div>
              </div>
              <div className="business-benefits-comparison-row">
                <div className="business-benefits-comparison-cell">MOQ Flexibility</div>
                <div className="business-benefits-comparison-cell">High minimum orders</div>
                <div className="business-benefits-comparison-cell business-benefits-our-brand">Low MOQ ✓</div>
              </div>
              <div className="business-benefits-comparison-row">
                <div className="business-benefits-comparison-cell">Branding Options</div>
                <div className="business-benefits-comparison-cell">Limited/None</div>
                <div className="business-benefits-comparison-cell business-benefits-our-brand">Full Customization ✓</div>
              </div>
              
              <div className="business-benefits-comparison-row">
                <div className="business-benefits-comparison-cell">Price</div>
                <div className="business-benefits-comparison-cell">High Price With same Features</div>
                <div className="business-benefits-comparison-cell business-benefits-our-brand">Affordable Price ✓</div>
              </div>
            </div>
          </div>

          {/* Final CTA */}
          <div className="business-benefits-cta">
            <div className="business-benefits-cta-content">
              <h3>Ready to Become Our Distributor?</h3>
              <p>Join the fastest growing hearing aid network in India</p>
              <div className="business-benefits-cta-buttons">
                <button onClick={openQuoteModal} className="business-benefits-cta-primary">
                  Apply for Distributorship →
                </button>
                <a href="#contact" className="business-benefits-cta-secondary">
                  Download Brochure
                </a>
              </div>
              <div className="business-benefits-cta-note">
                *Limited distributorship slots available per city
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Quote Modal */}
      <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
    </>
  );
};

export default BusinessBenefits;